"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxeGeomineCharge = void 0;
const tier_1 = require("./tier");
const enhancements_1 = require("./enhancements");
function getAxeGeomineCharge(dna) {
    const tier = (0, tier_1.getAxeTier)(dna);
    return enhancements_1.enhancementsConfig.geomineCharge.ranges[tier];
}
exports.getAxeGeomineCharge = getAxeGeomineCharge;
//# sourceMappingURL=charge.js.map